module.exports = __webpack_public_path__ + "static/media/dk2061.48f3bb17.png";